import { Outlet } from "react-router-dom";
import { useThemeSync } from "@hooks/useThemeSync";
import { useAppSelector } from "@app/hooks";
import { LeftNav } from "./LeftNav";
import "./shell.css";
import "../ui/ui.css";

/**
 * App shell layout. There is no top header: the left nav is the only chrome and
 * the main content runs full-height from the very top of the viewport (field /
 * tablet use — maximize the workspace). Applies the active theme to the DOM,
 * wraps content in the lineage scope (only tinted when the admin overlay is on),
 * and hosts the routed screen via <Outlet/>.
 */
export function AppShell() {
  useThemeSync();
  const lineageOn = useAppSelector((s) => s.prefs.lineageOverlay);

  return (
    <div className="app-shell">
      <LeftNav />
      <main className={`app-content${lineageOn ? " lineage-on" : ""}`}>
        <Outlet />
      </main>
    </div>
  );
}
